import React from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import type { ProviderConfig } from 'launchdarkly-react-client-sdk/lib/types';
import { useEnvironment } from '#core/Environment';
import { useProducts } from '#core/Products';
import { useInstitution } from '#core/Institution';
// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';

const LaunchDarklyProvider: React.FC = ({ children }) => {
  const { user, roles, groups, isAuthenticated } = useAuth(); // JME2
  const { launchDarklyConfig } = useEnvironment();
  const { products } = useProducts();
  const { institution } = useInstitution();
  const enabledProducts = products.reduce<string[]>(
    (carry, { name, auth: { userHasAccess } }) =>
      userHasAccess ? [...carry, name] : carry,
    [],
  );

  if (!launchDarklyConfig.clientSideID) {
    return <>children</>;
  }

  const ldParams: Omit<ProviderConfig, 'clientSideID'> = isAuthenticated
    ? {
        user: {
          key: user?.id,
          name: user?.name,
          email: user?.email,
          custom: {
            authRoles: roles,
            authGroups: groups,
            products: enabledProducts,
            institution: `${institution.institutionId} - ${institution.name}`,
          },
        },
      }
    : {
        user: {
          anonymous: true,
        },
      };

  return (
    <LDProvider clientSideID={launchDarklyConfig.clientSideID} {...ldParams}>
      {children}
    </LDProvider>
  );
};

export default LaunchDarklyProvider;
